import { gql } from '@apollo/client';

import { useGQLQuery } from 'hooks/useGQLQuery';

export enum EncryptionKeyType {
  tabapay = 'tabapay',
  greenDot = 'greendot',
}

export type EncryptionKey = {
  id: string;
  key: string;
  type: EncryptionKeyType;
  // name field is mainly used for debugging, it might change in the future.
  // We are using it temporarily as we migrate to the new key fetching API.
  name?: 'tabapay:stride' | 'tabapay:bancorp' | 'greendot';
};

type UseEncryptionKeysApi = {
  keys?: EncryptionKey[];
  error?: any;
};

const CARD_ENCRYPTION_KEY_QUERY = gql`
  query P2pCardEncryptionKeys {
    unauthenticated {
      p2p {
        card_encryption_keys {
          id
          type
          name
          key
        }
      }
    }
  }
`;

function useEncryptionKeys(): UseEncryptionKeysApi {
  const {
    data: graphqlData,
    error: graphqlError,
  } = useGQLQuery(CARD_ENCRYPTION_KEY_QUERY, { fetchPolicy: 'no-cache' });

  const keys = graphqlData?.unauthenticated?.p2p?.card_encryption_keys;
  return {
    keys,
    error: graphqlError,
  };
}

export default useEncryptionKeys;
